export default {
  formId: 'plantillasForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre de la Plantilla',
    },
    message: {
      name: 'message',
      label: 'Mensaje de la Respuesta',
    },
    category: {
      name: 'category',
      label: 'Categoría',
    },
    business: {
      name: 'business',
      label: 'Negocio',
    },
  },
};
